<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <dashboard-journal-entreprises v-if="listtype==='entreprises'" :identite="identite" />
        <dashboard-journal-partenaires v-if="listtype==='partenaires'" :identite="identite" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardJournalEntreprises from "./DashboardJournalEntreprises";
import DashboardJournalPartenaires from "./DashboardJournalPartenaires";

export default {
  props: ["listtype", "identite"],
  components: {
    DashboardJournalPartenaires,
    DashboardJournalEntreprises,
  },
  mounted() {},
  methods: {},
};
</script>

<style>
</style>
